import * as React from "react";
import useWebSocket from "react-use-websocket";
import { OpenChatMessage } from "@/types/open-chat";
import { useAppDispatch } from "@/store/hooks";
import { openChatApi } from "@/api/open-chat";

interface Props {
  conversationId: string;
  contentRef: React.RefObject<HTMLDivElement>;
}

interface WebSocketOpenChatMessage extends OpenChatMessage {
  event: "message" | "end";
}

export const OpenChatWebSocketHandler: React.FC<Props> = ({ contentRef, conversationId }) => {
  const { lastJsonMessage } = useWebSocket<WebSocketOpenChatMessage>(`/pf-open-chat/ws/${conversationId}`, {
    share: false,
    skipAssert: true,
    shouldReconnect: event => event?.code !== 1000,
  });
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (lastJsonMessage !== null) {
      let scroll = true;
      if (lastJsonMessage.event === "message" || lastJsonMessage.event === "end") {
        dispatch(
          openChatApi.util.updateQueryData("getMessages", conversationId, drafts => {
            const record = drafts.find(draft => draft.id === lastJsonMessage.id);
            if (!record) {
              drafts.push({
                ...lastJsonMessage,
              });
            } else {
              const index = drafts.indexOf(record);
              if (!drafts[index]["completed"]) {
                drafts[index]["content"] = drafts[index]["content"] + lastJsonMessage.content;

                if (lastJsonMessage.event === "end") {
                  drafts[index]["completed"] = true;
                  scroll = false;
                }
              } else {
                scroll = false;
              }
            }
          }),
        );
      }
      if (contentRef.current !== null && scroll) {
        contentRef.current.scrollTop = contentRef.current.scrollHeight;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, lastJsonMessage, dispatch]);

  return null;
};
